module.exports = __webpack_public_path__ + "img/ic_delivery.4f30a901.png";